import { render, staticRenderFns } from "./rightSide.vue?vue&type=template&id=af9c5746&scoped=true&"
import script from "./rightSide.vue?vue&type=script&lang=js&"
export * from "./rightSide.vue?vue&type=script&lang=js&"
import style0 from "./rightSide.vue?vue&type=style&index=0&id=af9c5746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9c5746",
  null
  
)

export default component.exports